import { Component, OnInit } from "@angular/core";
import { AuthenticationService, OktaAuthService } from "@appcore/service";

@Component({ template: `` })
export class CallbackComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService) {}

  async ngOnInit(): Promise<void> {
    // Handles the response from Okta and parses tokens
    await (this.authenticationService as OktaAuthService).handleAuthentication();
  }
}
